export default __webpack_public_path__ + "ff41ba9a995f45a4c0382310a449f835.png";